export interface CompanySecurityEventConfigTestResult {
  success: boolean;
  valid_credentials: boolean;
}

export enum S3AuthType {
  SecretAccessKey = 1, // Appboy::CustomerAWSFileHoster::AuthTypes::KEY
  RoleArn = 2, // Appboy::CustomerAWSFileHoster::AuthTypes::ROLE
}

export enum ExportWarehouseType {
  AwsS3 = 0, // Braze::FileHosting::ClientFactory::DataWarehouses::AWS_S3
  Azure = 1, // Braze::FileHosting::ClientFactory::DataWarehouses::AZURE
  Gcs = 2, // Braze::FileHosting::ClientFactory::DataWarehouses::GCS
}

export type PostCompaniesCompanyIdSecuritySettingsSecurityEventConfigTestProps =
  | {
      company_id: string;
      export_warehouse_type: ExportWarehouseType.AwsS3;
      s3_data_export_bucket_name: string;
      s3_data_export_bucket_folder: string;
      s3_auth_type: S3AuthType.SecretAccessKey;
      s3_access_key: string;
      s3_access_secret: string;
    }
  | {
      company_id: string;
      export_warehouse_type: ExportWarehouseType.AwsS3;
      s3_external_id: string;
      s3_data_export_bucket_name: string;
      s3_data_export_bucket_folder: string;
      s3_auth_type: S3AuthType.RoleArn;
      s3_role_arn: string;
    }
  | {
      company_id: string;
      export_warehouse_type: ExportWarehouseType.Azure;
      azure_storage_container_name: string;
      azure_storage_prefix: string;
      azure_connection_string: string;
    }
  | {
      company_id: string;
      export_warehouse_type: ExportWarehouseType.Gcs;
      gcs_bucket_name: string;
      gcs_prefix: string;
      gcs_credentials_string: string;
    };
